import { render } from "./LearningGoalActionsBar.vue?vue&type=template&id=1cee049d&scoped=true"
import script from "./LearningGoalActionsBar.vue?vue&type=script&lang=js"
export * from "./LearningGoalActionsBar.vue?vue&type=script&lang=js"

import "./LearningGoalActionsBar.vue?vue&type=style&index=0&id=1cee049d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cee049d"]])

export default __exports__